export default "__VITE_ASSET__CkxDAPZe__"